import { StyleSheet } from "react-native"
import { baseColors } from "../../Constants/baseStyles"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: baseColors.white,
        marginBottom: 12
    },
    content: {
        alignItems: "center"
    },
    video: {
        flex: 0.4,
        borderRadius: 10,
        height: 90,
        backgroundColor: baseColors.green.pastel
    },
    label: {
        flex: 0.55
    }
})

export default styles
